//#region imports
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CharacteristicsComponentModel } from '../characteristics.model';
import { SectionService } from 'src/app/services/section.service';
import { Globals } from 'src/app/services/globals';
//#endregion

@Component({
  selector: 'app-characteristics-question',
  templateUrl: './characteristics-question.component.html',
  styleUrls: ['./characteristics-question.component.css']
})
export class CharacteristicsQuestionComponent implements OnInit {
  //#region variables
  showPrevious = false;
  characteristicsComponent: CharacteristicsComponentModel;
  //#endregion

  //#region methods
  constructor(
    private characteristicService: CharacteristicService, private sectionService: SectionService,
    private changeDetectorRef: ChangeDetectorRef, private notificationService: NotificationService, 
    private globals: Globals) {
    if (this.sectionService.getClientIdPresent()) {
      this.showPrevious = true;
    } else {
      this.characteristicService.getShowPrevious().subscribe((value) => {
        this.showPrevious = value;
      });
    }
  }

  ngOnInit() {
    this.characteristicService.getCharacteristicsComponent().subscribe((value) => {
      this.characteristicsComponent = {
        Question1: value.Question1, Question2: value.Question2, Question3: value.Question3,
        Question4: value.Question4, Question5: value.Question5
      };
      if(value.Question1){
        if(!this.globals.charpage1){
        this.globals.trackPageActivity += 'P1-1';
      this.globals.charpage1 = true;}
      }else if(value.Question2){ 
        if(!this.globals.charpage2){this.globals.trackPageActivity += '; P1-2'; 
        this.globals.charpage2 = true;} 
      }else if(value.Question3){ if(!this.globals.charpage3){this.globals.trackPageActivity += '; P1-3';
      this.globals.charpage3 = true;}
      }else if(value.Question4){ if(!this.globals.charpage4){this.globals.trackPageActivity += '; P1-4';
      this.globals.charpage4 = true;}
      }else if(value.Question5){ if(!this.globals.charpage5){this.globals.trackPageActivity += '; P1-5';
      this.globals.charpage5 = true;}
      }
    });
    this.changeDetectorRef.detectChanges();
  }

  saveDialog() {
    this.notificationService.saveDialog();
  }
  //#endregion
}
